<template>
  <div class="merchant-info-list" v-loading="loadingPage">
    <div class="header">
      <div class="title">门店管理</div>
      <div class="search">
        <el-form inline class="inline-form" :model="searchForm" label-width="85px" label-position="left">
          <el-form-item label="门店搜索">
            <el-input v-model="searchForm.merchantName" placeholder="请输入店铺简称" size="small"/>
          </el-form-item>
          <el-form-item label="商户编号" style="margin-left: 30px;">
            <el-input v-model="searchForm.merchantId" size="small" placeholder="请输入商户编号"/>
          </el-form-item>
          <!-- <el-form-item label="门店编号">
            <el-input v-model="searchForm.transToolCustomerName" placeholder="请输入门店编号"/>
          </el-form-item> -->
          <el-button type="primary" @click="search" class="btnBase searchBtn bs-btn">查询</el-button>
          <el-button type="primary" @click="exportStore" class="btnBase searchBtn bs-btn">导出门店信息</el-button>
        </el-form>
      </div>
    </div>
    <div class="table-list">
      <div class="table-data-content">
        <el-table :data="tableData" style="width: 100%;" border v-loading="loadingTable">
          <el-table-column prop="merchantName" label="门店名称" align="center"/>
          <el-table-column prop="merchantId" label="商户编号" align="center"/>
          <el-table-column prop="shopId" label="门店编号" align="center"/>
          <el-table-column label="操作" align="center">
            <template slot-scope="{row}">
              <span class="table-btn" @click="viewDetail(row, 1)">查看详情</span>
              <span class="table-btn" @click="viewDetail(row, 2)">退款设置</span>
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" class="paginationBox">
          <el-pagination
            v-if="page.count > 0"
            class="pagination"
            :page-size="page.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="page.count"
            :current-page="page.pageNo"
            @current-change="onChangeCurrentPage"/>
        </el-col>
      </div>
    </div>
    <el-dialog title="退款配置" :visible.sync="dialogVisible" width="600px" @close="handleCancel" center>
      <el-form ref="codeForm" :model="dialogForm" auto-complete="on" label-width="200px">
        <el-form-item prop="merchantId" label="商户号">{{dialogForm.targetMerchantId}}</el-form-item>
        <el-form-item prop="refundIntraDayFlag" label="是否允许当日退款">
          <el-radio-group v-model="dialogForm.refundIntraDayFlag">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="refundNextDayFlag" label="是否允许隔日退款">
          <el-radio-group v-model="dialogForm.refundNextDayFlag">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button class="bs-btn2" @click="handleCancel">取消</el-button>
        <el-button class="bs-btn" type="primary" @click="handleSubmit" :loading="dialogLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryShopList, shopMerchantExport, getMerchantPosRefundConfig, updateMerchantPosRefundConfig,
} from "@/api/merchant-info";

export default {
  name: 'merchant-info',
  data() {
    return {
      searchForm: {
        merchantName: "",
        merchantId: "",
      },
      page: {
        pageNo: 1,
        count: 0,
        pageSize: 10,
      },
      tableData: [],
      loadingTable: false,
      loadingPage: false,
      dialogVisible: false,
      dialogLoading: false,
      dialogForm: {
        targetMerchantId: '',
        refundIntraDayFlag: 1, // 当日退款限制 1：可以退 0:不可退
        refundNextDayFlag: 1, // 次日以后退款限制 1：可以退 0:不可退
      },
    };
  },
  computed: {
    loginInfo() {
      return JSON.parse(window.localStorage.getItem('LOGIN_INFO'));
    },
  },
  created() {
    this.queryShopList();
  },
  methods: {
    viewDetail({ merchantId, shopType }, type) {
      switch (type) {
        case 1: this.$router.push({ path: "/merchant-info/modifyInfo", query: { merchantId, shopType } });
          break;
        case 2: this.queryConfig(merchantId);
          break;
        default: break;
      }
    },
    queryConfig(targetMerchantId) {
      getMerchantPosRefundConfig({ targetMerchantId }).then(({ data: { code, data: { refundIntraDayFlag, refundNextDayFlag } } }) => {
        if (code === '0') {
          this.dialogForm = { targetMerchantId, refundIntraDayFlag, refundNextDayFlag };
          this.dialogVisible = true;
        }
      });
    },
    search() {
      this.page.pageNo = 1;
      this.queryShopList();
    },
    exportStore() {
      this.loadingPage = true;
      shopMerchantExport({
        reqMerchantName: this.searchForm.merchantName,
        reqMerchantId: this.searchForm.merchantId,
      }).then((res) => {
        this.loadingPage = false;
        if (res.data.code === '0') {
          this.$message.success('导出成功，请到下载中心下载报表文件！');
        }
      });
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage(page) {
      this.page.pageNo = page;
      this.queryShopList();
    },
    // 获取门店列表
    queryShopList() {
      this.loadingPage = true;
      return queryShopList(Object.assign(this.searchForm, this.page)).then((res) => {
        this.loadingPage = false;
        if (res.data.error_code === 0) {
          this.tableData = res.data.data.list;
          this.page.count = res.data.data.totalCount;
        }
      });
    },
    handleCancel() {
      this.dialogForm = {
        merchantId: '',
        refundIntraDayFlag: 1, // 当日退款限制 1：可以退 0:不可退
        refundNextDayFlag: 1, // 次日以后退款限制 1：可以退 0:不可退
      };
      this.dialogVisible = false;
    },
    handleSubmit() {
      this.dialogLoading = true;
      updateMerchantPosRefundConfig(this.dialogForm).then(({ data: { code } }) => {
        if (code === '0') {
          this.$message.success('操作成功');
          this.handleCancel();
          this.search();
        }
      }).finally(() => {
        this.dialogLoading = false;
      });
    },
  },
};
</script>
<style lang="scss">
.merchant-info-list {
  .btn-base {
    height: 32px;
    margin-top: 5px;
    line-height: 0px;
  }

  background-color: #f7f7f7;

  > .header {
    .search {
      margin-top: 40px;
      margin-bottom: 20px;
    }

    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .table-list {
    overflow: hidden;
    background: #f7f7f7;

    .table-data-content {
      padding: 40px 50px;
      overflow: hidden;
      background: #fff;
      border-top: 20px solid #eee;

      .table-btn {
        margin-right: 10px;
        color: #1395ff;
        cursor: pointer;
      }
    }
  }
}
</style>
